export default __webpack_public_path__ + "static/media/papel_clara.f70223f9.png";